import { useTheme } from "next-themes";
import { Link, useLocation } from "react-router-dom";
import { Moon, Sun, ExternalLink } from "lucide-react";
import { Button } from "../components/ui/button";

export const HeaderNav = () => {
  const { theme, setTheme } = useTheme();
  const location = useLocation();
  const isPublic = location.pathname.startsWith("/v/");

  return (
    <header
      data-testid="main-header-nav"
      className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
        {isPublic ? (
          <div data-testid="brand-logo-static" className="flex items-center gap-3">
            <span className="flex h-11 items-center justify-center overflow-hidden rounded-xl bg-[#0a1a3a] shadow-lg shadow-primary/20 ring-1 ring-white/10">
              <img
                src="/logo-iudp.png"
                alt="Igreja Unida Deus Proverá"
                data-testid="brand-logo-image"
                className="h-11 w-auto object-contain"
              />
            </span>
            <span className="font-display text-lg font-extrabold tracking-tight">
              QR IUDP
            </span>
          </div>
        ) : (
          <Link
            to="/"
            data-testid="brand-logo-link"
            className="flex items-center gap-3 transition-opacity hover:opacity-80"
          >
            <span className="flex h-11 items-center justify-center overflow-hidden rounded-xl bg-[#0a1a3a] shadow-lg shadow-primary/20 ring-1 ring-white/10">
              <img
                src="/logo-iudp.png"
                alt="Igreja Unida Deus Proverá"
                data-testid="brand-logo-image"
                className="h-11 w-auto object-contain"
              />
            </span>
            <span className="font-display text-lg font-extrabold tracking-tight">
              QR IUDP
            </span>
          </Link>
        )}

        <div className="flex items-center gap-2">
          {!isPublic && (
            <Button
              asChild
              variant="ghost"
              size="sm"
              data-testid="nav-preview-public-link"
              className="hidden sm:inline-flex"
            >
              <Link to="/v/main">
                <ExternalLink className="mr-2 h-4 w-4" />
                Ver página pública
              </Link>
            </Button>
          )}
          <Button
            variant="outline"
            size="icon"
            data-testid="theme-mode-toggle"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="rounded-full"
            aria-label="Alternar tema"
          >
            <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          </Button>
        </div>
      </div>
    </header>
  );
};
